// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"74d28803","453":"0f53e48b","455":"0ee41233","977":"fff0fa8d"}[chunkId] + ".chunk.js";
};